import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { serverByLtvCurrency, serverByLtv } from "@/api/dataAll/accountLtv";
import * as echarts from "echarts";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "serverRoleLTV",
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      value2: [],
      tableData: [],
      dates: [],
      series: [],
      intReq: [],
      Dynamic: [],
      PrimitiveDy: [],
      screen: [],
      cellStylekeys: ["LTV"],
      searchData: {
        kind: 1
      },
      isRollingList: [{
        label: this.$t('yes'),
        value: 1
      }, {
        label: this.$t('no'),
        value: 0
      }],
      characterList: [{
        label: this.$t('characterSword'),
        value: 1
      }, {
        label: this.$t('characterThunder'),
        value: 2
      }, {
        label: this.$t('characterIce'),
        value: 3
      }]
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClickNew: function searchClickNew() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var searchCurrency, reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.timeInterval();

              case 2:
                searchCurrency = _this2.$store.state.d2admin.serchSelect.searchCurrency;
                reqFn = searchCurrency.length ? serverByLtvCurrency : serverByLtv; // let reqFn = accLtv
                // if (this.currencyClose && !this.searchData.pay_channel) {
                //   reqFn = accLtv_currency
                // } else if (this.searchData.pay_channel) {
                //   reqFn = accountltvCurrencyOther
                // }

                _this2.screen = [];
                _this2.PrimitiveDy = [];
                _this2.searchData.server_id = _this2.paramsData.server_id;
                _this2.searchData.character_id = _this2.paramsData.character_id;
                _this2.searchData.is_roll = _this2.paramsData.is_roll;

                _this2.searchClickPoints(reqFn, 1);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(qudata) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, allAmount, DynamicList, k, _k, data, obj, j;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (qudata.length) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                res = {
                  account_total: 0,
                  pay_account_num: 0,
                  ltv_data: {},
                  ltv_total: {}
                };
                allAmount = {};
                console.log("qudata===", qudata);
                qudata.forEach(function (i) {
                  res.account_total = res.account_total + i.account_total;
                  res.pay_account_num = res.pay_account_num + i.pay_account_num;
                  res.ltv_data = _objectSpread(_objectSpread({}, res.ltv_data), i.ltv_data);

                  for (var k in i.ltv_data) {
                    for (var j in i.ltv_data[k].amount) {
                      if (!allAmount.hasOwnProperty(j)) {
                        allAmount[j] = 0;
                      }

                      allAmount[j] = allAmount[j] + i.ltv_data[k].amount[j];
                    }
                  }
                });
                DynamicList = [];

                for (k in allAmount) {
                  res.ltv_total[k] = res.account_total ? allAmount[k] / res.account_total : 0;
                  DynamicList.push({
                    label: "LTV".concat(k),
                    prop: 'LTV' + k,
                    tableText: k == 1 ? "LTV".concat(k, "A") : "LTV".concat(k),
                    desc: k == 1 ? _this3.$t('firstDayUserAverageValue') : ''
                  });
                }

                if (!_this3.screen.length) {
                  _this3.screen = DynamicList.map(function (item) {
                    return item.prop;
                  });
                }

                _this3.PrimitiveDy = [].concat(DynamicList);
                _context2.next = 12;
                return _this3.timeInterval();

              case 12:
                _this3.tableData = [];
                _this3.dates = [];
                _this3.series = [];
                delete res.ltv_total['0'];
                console.log("res==", res);
                res.ltv_data[_this3.$t('total')] = {
                  ltv: res.ltv_total,
                  other: {
                    new_account_num: res.account_total,
                    pay_account_num: res.pay_account_num
                  }
                };

                for (_k in res.ltv_data) {
                  data = {
                    date: _k,
                    new_account_num: res.ltv_data[_k].other.new_account_num,
                    pay_account_num: res.ltv_data[_k].other.pay_account_num
                  };

                  _this3.dates.push(_k);

                  obj = {
                    name: _k,
                    type: "line",
                    data: [],
                    smooth: true
                  };

                  for (j in res.ltv_data[_k].ltv) {
                    data['LTV' + j] = res.ltv_data[_k].ltv[j] == '/' ? 0.000 : _this3.$utils.conversion(res.ltv_data[_k].ltv[j]).toFixed(3);
                    obj.data.push(data['LTV' + j]);
                  }

                  _this3.series.push(obj);

                  _this3.tableData.push(data);

                  console.log("this.tableData==", _this3.tableData);
                }

                _this3.screenControls();

                _this3.$nextTick(function () {
                  _this3.getechart();

                  _this3.getTableRight();
                });

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    screenControls: function screenControls() {
      var _this4 = this;

      var list = [];
      this.PrimitiveDy.forEach(function (item) {
        _this4.screen.forEach(function (citem) {
          if (item.prop == citem) {
            list.push(item);
          }
        });
      });
      setTimeout(function () {
        _this4.Dynamic = list;
      }, 20);
      this.setTableRight(0);
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("dataLtvEchart");
      var myChart = echarts.init(chartDom);
      var option;
      var dateCp = JSON.parse(JSON.stringify(this.dates)).splice(0, this.dates.length - 1);
      option = {
        title: {
          text: this.$t('serverRoleLtvTitle')
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: dateCp,
          width: '80%'
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: this.PrimitiveDy.map(function (item) {
            return item.prop;
          })
        },
        yAxis: {
          type: "value"
        },
        series: this.series
      };
      option && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('newRoleLabel'),
        prop: 'new_account_num'
      }, {
        label: this.$t('newPayRoleNum'),
        prop: 'pay_account_num'
      }].concat(_toConsumableArray(this.Dynamic));
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};